export class TextLogic {
    static spaceOutCapitalization(value: string): string {
        return value?.split(/(?=[A-Z])/).join(' ');
    }
}
